export default class DarkTheme {
    static isDark() {
        return document.querySelector('html').classList.contains('dark');
    }
}